import { createContext } from 'react'

export const initialReplyTweetId = ''

export const ReplyTweetContext = createContext(initialReplyTweetId)
